import type { RouteObject } from "react-router-dom";
import { authRoutes } from "./modules/auth.routes";
import { createPublicRoutes } from "./modules/public.route";
import { fallbackRoutes } from "./modules/fallback.routes";

export function createRoutes(): RouteObject[] {
  return [...authRoutes, ...createPublicRoutes(), ...fallbackRoutes];
}
